<template>
  <div>
    <navigation-main bg="true" />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section">
            <div class="container">
              <div class="row ">
                <div class="col-12">
                  <h2 class="text-black mb-0">
                    Data Protection
                  </h2>
                  <hr
                    class="divider dark m-0 mb-1"
                    style="max-width: 100% !important;"
                  />
                </div>
                <div class="col-12">
                  <p class="mb-4">
                    The central research task in this project is the <i>recognition of the general semantic
                    class of objects</i> that appear in driving scenes, i.e., the segmentation of scenes in
                    regions that correspond to cars, road, humans, sidewalk, bicycles, buses etc. An
                    indicative example for the kind of inputs and outputs we deal with is shown below
                    (from the <a href="https://muses.vision.ee.ethz.ch">MUSES</a> dataset).
                  </p>
                  <div style="overflow-x:auto;">
                    <table style="width:100%">
                      <tr>
                        <td style="text-align:center">
                          <img height=200px src="/imgs/rgb_example.png"
                          />
                        </td>
                        <td style="text-align:center">
                          <img height=200px src="/imgs/panoptic_example.png"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align:center; vertical-align:top">
                          Example RGB image
                        </td>
                        <td style="text-align:center; vertical-align:top">
                          Corresponding panoptic segmentation
                        </td>
                      </tr>
                    </table>
                  </div>
                  <p class="mb-4">
                    In addition to a normal RGB camera, our setup includes the following three sensors:
                    <ul class="ml-3">
                      <li>
                        LiDAR
                      </li>
                      <li>
                        RADAR
                      </li>
                      <li>
                        Event-based camera
                      </li>
                    </ul>
                    These sensors provide complementary information to the RGB camera, which is 
                    essential for constructing a scene recognition system robust to adverse visual conditions.
                  </p>
                  <p class="mb-4">
                    While RGB images of driving scenes generally contain personal data, for
                    instance human faces or license plates of vehicles, such information is not obtainable
                    <i>without extraordinary effort</i> from the data captured by the other sensors (e.g. due to low
                    spatial resolution).
                    More importantly, <i>our research
                    task is by nature not related to the identification of individual persons or
                    vehicles</i> in the processed images. Instead of determining which specific
                    persons are visible in the input image, our purpose is limited to 
                    distinguishing person from sidewalk, car from road, etc.
                  </p>
                  <p class="mb-4">
                    Owing to this fact, our research can also be conducted on
                    anonymized versions of the input images.  
                    Therefore, all publicly released RGB images of the dataset will be anonymized as per standard practice by manually
                    annotating and blurring human faces and vehicle license plates.
                    Note that, it is impossible to perform this anonymization of the data 
                    right from the first stage of our pipeline, thus the original images will be saved on our private server
                    in an intermediate stage.
                  </p>
                </div>
              </div>

            </div>
          </section>
          <section class="page-section">
            <div class="container">
              <div class="row ">
                <div class="col-12">
                  <h3 class="text-black mb-0">
                    Declaration on Handling of Personal Data
                  </h3>
                  <hr
                    class="divider dark m-0 mb-1"
                    style="max-width: 100% !important;"
                  />
                </div>
                <div class="col-12">
                  <p class="mb-4">
                    The construction of this dataset constitutes processing of 
                    personal data, as the images of driving scenes, which we collect in the 
                    greater area of Zurich, Switzerland, contain personal data. 
                    Our data processing pipeline involves dedicated measures for data protection 
                    which pertain to the entire life cycle of the data, i.e., in the
                    collection, storage, annotation, anonymization, and distribution of the data.
                  </p>
                  <p class="mb-4">
                    However, if you find yourself or your personal belongings
                    in the dataset, you can
                    <a href="mailto:efcl.sensor.fusion@zohomail.eu">contact us</a>
                    and we will immediately delete the respective images from
                    our server.
                  </p>
                </div>
              </div>

            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  name: "DataProtectionPage.vue",
  components: {
    NavigationMain
  }
};
</script>
